module.exports = __webpack_public_path__ + "img/top-bar.d6f68022.png";